import { toast } from "sonner";

// Native share sheet on mobile / supporting browsers; clipboard-copy fallback
// everywhere else. Works for any job listing (card or detail page).
export async function shareJob(job) {
  const url = `${window.location.origin}/jobs/${job.job_id}`;
  const shareData = {
    title: `${job.title} · ${job.company}`,
    text: `${job.title} at ${job.company} — via KARM`,
    url,
  };
  if (navigator.share) {
    try {
      await navigator.share(shareData);
    } catch {
      /* user cancelled the share sheet — no-op */
    }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied — share it anywhere");
  } catch {
    toast.error("Could not copy link");
  }
}
